import IconShoppingCart from "@/assets/icons/shopping-cart.svg?react";
import IconDonFilledLinear from "@/assets/icons/don-filled-linear.svg?react";
import Image from "@/components/base/Image.tsx";
import { formatNumber } from "@/shared/utils";
import type { Product } from "../api";

interface ProductCardProps {
  product: Product;
  onClick: (product: Product) => void;
}

// Marketplace-style tile: square image at top, title and DON price below.
// Designed for a 2-column grid in PartnerSinglePage so products feel like
// shop items rather than a contact-list row.
export default function ProductCard({ product, onClick }: ProductCardProps) {
  return (
    <button
      type="button"
      onClick={() => onClick(product)}
      className="block w-full text-left rounded-2xl bg-gray-4 border border-white/[0.04] overflow-hidden active:scale-[0.98] transition-transform duration-150"
    >
      <div className="relative w-full aspect-square bg-white/[0.04] flex-center">
        {product.icon ? (
          <Image
            urls={product.icon}
            size="small"
            imgClassName="w-full h-full object-cover"
            wrapperClassName="w-full h-full"
            alt={product.title}
          />
        ) : (
          <IconShoppingCart className="size-10 text-gray-1/50" />
        )}
        {product.is_hot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-red text-white text-[10px] font-bold leading-none uppercase tracking-wide">
            HOT
          </span>
        )}
      </div>

      <div className="px-3 py-2.5">
        <p className="text-sm font-semibold text-white leading-130 line-clamp-2 min-h-[36px]">
          {product.title}
        </p>
        <div className="flex items-center gap-1 mt-1.5">
          <IconDonFilledLinear width="14" height="14" />
          <span className="text-base font-bold text-orange-100 leading-130">
            {formatNumber(product.don_reward)}
          </span>
        </div>
      </div>
    </button>
  );
}
